/*
Radio air times: entered and shown in Madrid time, stored and sent in UTC.

ps-back keeps every airing as a UTC instant (ISO 8601 string in the admin API). The radio
team thinks in Madrid wall-clock time, which is what pspanel stored, so the manager
converts at the edge: the form shows `YYYY-MM-DD` + `HH:mm` in Europe/Madrid and sends
`moment.tz('YYYY-MM-DD HH:mm', 'Europe/Madrid').toISOString()`.

Daylight-saving edges are moment-timezone's, the same rule the backend and the migration
use: the repeated hour on the last Sunday of October takes its first occurrence, and the
skipped hour in March is shifted forward.

CommonJS so radioTime.test.js runs under plain node, like cmsTabs.js.
*/
const moment = require('moment-timezone');

const ZONE = 'Europe/Madrid';
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const TIME_PATTERN = /^\d{2}:\d{2}$/;

// The API sends ISO strings, but a Mongoose date that slipped through as a GraphQL String
// arrives as epoch millis; accept both rather than render 1970.
const toMoment = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const raw = String(value);
  const parsed = /^\d+$/.test(raw) ? moment(Number(raw)) : moment(raw, moment.ISO_8601);
  return parsed.isValid() ? parsed : null;
};

// 'YYYY-MM-DD', 'HH:mm' in Madrid -> UTC ISO string, or null when either part is invalid.
const madridToUtcIso = (date, time) => {
  if (!DATE_PATTERN.test(date || '') || !TIME_PATTERN.test(time || '')) return null;
  const local = moment.tz(`${date} ${time}`, 'YYYY-MM-DD HH:mm', true, ZONE);
  return local.isValid() ? local.toISOString() : null;
};

// UTC instant -> { date: 'YYYY-MM-DD', time: 'HH:mm' } in Madrid; empty parts when invalid.
const utcToMadridParts = (value) => {
  const parsed = toMoment(value);
  if (!parsed) return { date: '', time: '' };
  const local = parsed.tz(ZONE);
  return { date: local.format('YYYY-MM-DD'), time: local.format('HH:mm') };
};

// UTC instant -> Madrid display string; '' when missing or invalid.
const formatMadrid = (value, format = 'DD/MM/YYYY HH:mm') => {
  const parsed = toMoment(value);
  return parsed ? parsed.tz(ZONE).format(format) : '';
};

// Today's date in Madrid, 'YYYY-MM-DD' (the default for a new airing row).
const madridToday = (now = Date.now()) => moment(now).tz(ZONE).format('YYYY-MM-DD');

module.exports = {
  ZONE,
  DATE_PATTERN,
  TIME_PATTERN,
  madridToUtcIso,
  utcToMadridParts,
  formatMadrid,
  madridToday,
};
